package br.com.vvrefeicoes.portal.core.util

import kotlin.math.abs
import kotlin.math.roundToLong

object PercentFormatter {
    fun format(value: Double): String {
        val scaled = (value * 100).roundToLong()
        val whole = abs(scaled) / 100
        val fraction = abs(scaled) % 100
        val body = "$whole,${fraction.toString().padStart(2, '0')}"
        return if (scaled < 0) "-$body" else body
    }

    fun parse(text: String): Double? {
        val normalized = text.trim().replace(',', '.')
        if (normalized.isEmpty()) return null
        val value = normalized.toDoubleOrNull() ?: return null
        return value.takeIf { it in 0.0..100.0 }
    }
}
